import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { selectors as apiSelectors } from 'zender-api-client';

import * as appSelectors from '../../../../selectors';
import Channel from './Channel.component';

const ChannelContainer = props => <Channel {...props} />;

const mapStateToProps = state => ({
	locale: appSelectors.locale.localeSelector(state),
	config: apiSelectors.config.configSelector(state),
	queryParams: appSelectors.ui.queryParamsSelector(state),
	pathName: appSelectors.router.pathNameSelector(state),
});

const mapDispatchToProps = () => ({});

ChannelContainer.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ChannelContainer);



// WEBPACK FOOTER //
// ./src/ui/channels/children/channel/Channel.container.js